// Mesmas regras no app (bigou-pedidos-mobile, app/lib/WhatsAppCliente.js). Ver docs/whatsapp-status-pedido-cardapio-digital.md.

const STATUS_ACEITO = 1;
const STATUS_SAIU_PARA_ENTREGA = 2;

const somenteDigitos = (valor) => String(valor || '').replace(/\D/g, '');

export const isRetirada = (pedido) => !!(pedido && pedido.endereco && pedido.endereco.id == -1);

export const tipoAvisoCliente = (pedido) => {
  if (pedido.status == STATUS_ACEITO) return 'aceito';
  return isRetirada(pedido) ? 'retirada' : 'entrega';
};

// Mesma origem do filtro `telefone`: cadastro do usuário e, sem ele, o telefone do endereço.
export const telefoneWhatsAppCliente = (pedido) => {
  if (!pedido) return '';
  const usuario = pedido.usuario || {};
  const endereco = pedido.endereco || {};
  const ddd = usuario.ddd && usuario.telefone ? usuario.ddd : endereco.ddd;
  const telefone = usuario.ddd && usuario.telefone ? usuario.telefone : endereco.telefone;
  const numero = somenteDigitos(ddd).replace(/^0+/, '') + somenteDigitos(telefone);
  return numero.length >= 10 ? `55${numero}` : '';
};

const MENSAGENS = {
  aceito: (id) => `Seu pedido ${id} foi aceito e está em preparo!`,
  retirada: (id) => `Seu pedido ${id} está pronto para retirada!`,
  entrega: (id) => `Seu pedido ${id} saiu para entrega!`,
};

export const mensagemStatusPedido = (pedido) => MENSAGENS[tipoAvisoCliente(pedido)](pedido.id);

export const podeAvisarClienteWhatsApp = (pedido) => !!pedido
  && pedido.cardapio_digital == 1
  && (pedido.status == STATUS_ACEITO || pedido.status == STATUS_SAIU_PARA_ENTREGA)
  && !!telefoneWhatsAppCliente(pedido);

export const linkWhatsAppStatusPedido = (pedido) =>
  `https://api.whatsapp.com/send?phone=${telefoneWhatsAppCliente(pedido)}&text=${encodeURIComponent(mensagemStatusPedido(pedido))}`;
